import styled from "@emotion/styled";
import { Chip } from "@mui/material";

/**
 * Component used in custom selected values renderer
 */
export const StyledChip = styled(Chip)(
    ({ theme }) => ({
        borderRadius: theme.kaltura.shape.roundness1,
        backgroundColor: theme.kaltura.palette.tone7,
        color: theme.kaltura.palette.tone1,
        fontSize: theme.typography.fontSize,
        fontWeight: theme.typography.fontWeightBold,
        height: 24,
        display: "flex",
        alignItems: "center",
        lineHeight: 16,
        "&.MuiChip-root": {
            maxWidth: 220,
        },
        "& .MuiChip-deleteIcon": {
            color: theme.kaltura.palette.tone1,
        },
    }),
    { label: "StyledChip" }
);

export const StyledLi = styled.li(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));
